/**
 * Visually-hidden link that becomes visible when keyboard-focused.
 * Allows keyboard and screen-reader users to bypass the sidebar/header
 * and jump straight to the page's main content region.
 *
 * Place at the very top of each layout. The layout's <main> element must
 * carry `id="main"` for the link to land.
 */
export function SkipLink() {
  return (
    <a
      href="#main"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-3 focus:py-2 focus:bg-white focus:text-black focus:shadow-lg focus:rounded focus:text-sm focus:font-semibold"
    >
      Skip to main content
    </a>
  );
}
